// UrlOtpLoginLoader.js
import { connect } from 'react-redux';
import loadUrlOtpLogin from '../action/loadUrlOtpLogin.js';
import UrlLoader from '../component/UrlLoader.jsx';

const mapDispatchToProps = dispatch => {
  return {
    urlHandler: ({ url }) => dispatch(loadUrlOtpLogin({ url })),
  };
};

export default connect(null, mapDispatchToProps)(UrlLoader);
